<div class="log">
  <sgt-accordion>
    <header header>
      <h2 class="accordion-title">Criação e Alteração</h2>
      <p class="mb-0">Informações de criação e última alteração do usuário</p>
    </header>

    <div class="row">
      <div class="form-group col-12 col-md-6 col-xl-3">
        <label class="col-form-label">Criando Em</label>
        <input type="text" class="form-control" value="{{log?.createdAt | date: 'dd/MM/yyyy HH:mm'}}" disabled readonly/>
        <span class="form-text">Quando o usuário foi criado</span>
      </div>
      <div class="form-group col-12 col-md-6 col-xl-3">
        <label class="col-form-label">Criando Por</label>
        <sgt-avatar
            [settings]="{
                isShowLabelNameRight: true,
                fullName: log?.nomeUsuarioCreated,
                imageUrl: log?.avatarUrlUsuarioCreated
            }">
        </sgt-avatar>
        <span class="form-text">Quem criou o usuário</span>        
      </div>
      <div class="form-group col-12 col-md-6 col-xl-3">
        <label class="col-form-label">Alterado Em</label>
        <input type="text" class="form-control" value="{{log?.updatedAt | date: 'dd/MM/yyyy HH:mm'}}" disabled readonly/>
        <span class="form-text">Quando o usuário foi alterado</span>        
      </div>
      <div class="form-group col-12 col-md-6 col-xl-3">
        <label class="col-form-label">Alterado Por</label>
        <sgt-avatar
            [settings]="{
                isShowLabelNameRight: true,
                fullName: log?.nomeUsuarioUpdated,
                imageUrl: log?.avatarUrlUsuarioUpdated
            }">
        </sgt-avatar>
        <span class="form-text">Quem alterou o usuário</span>        
      </div>                  
    </div>
  </sgt-accordion>  

  <sgt-accordion>
    <header header>
      <h2 class="accordion-title">Histórico de Situações</h2>
      <p class="mb-0">Registros de alterações da situação do usuário</p>
    </header>

    <ng-template [ngIf]="log?.dataInativacao">
      <div class="row">
        <div class="form-group col-12 col-md-6">
          <label class="col-form-label">Inativado Em</label>
          <input type="text" class="form-control" value="{{log?.dataInativacao | date: 'dd/MM/yyyy HH:mm'}}" disabled readonly/>
          <span class="form-text">Quando o usuário foi inativado</span>
        </div>

        <div class="form-group col-12 col-md-6">
          <label class="col-form-label">Inativado Por</label>
          <sgt-avatar
              [settings]="{
                  isShowLabelNameRight: true,
                  fullName: log?.nomeUsuarioInativacao,
                  imageUrl: log?.avatarUrlUsuarioInativacao
              }">
          </sgt-avatar>
          <span class="form-text">Quem inativou o usuário</span>
        </div>
      </div> 
      
      <div class="row">
        <div class="form-group col-12">
          <label class="col-form-label">Justificativa</label>
          <textarea rows="5" class="form-control" sgtAutosize disabled readonly>{{log?.justificativaInativacao}}</textarea>
          <span class="form-text">Justificativa do por que o usuário foi inativado</span>    
        </div>
      </div>
    </ng-template>
    
    <sgt-log-situacao-table
      [idUsuario]="idUsuario">
    </sgt-log-situacao-table>    
  </sgt-accordion>

  <sgt-accordion>
    <header header>
      <h2 class="accordion-title">Histórico de Acessos</h2>
      <p class="mb-0">Registros de acessos do usuário</p>
    </header>
    
    <sgt-log-acesso-table
      [idUsuario]="idUsuario">
    </sgt-log-acesso-table>    
  </sgt-accordion>  
</div>